import React, { ReactNode } from "react";
import { createPortal } from "react-dom";
import "./ModalsWrapper.css"

type ModalsWrapperProps = {
  children: ReactNode;
  shouldShowModal: boolean;
  shouldBackgroundClickHideModal?: boolean;
  backgroundColor?: string;
  hideModal:() => void;
  showModal?:() => void;
  portaled?: boolean;
};

const ModalsWrapper: React.FC<ModalsWrapperProps> = ({
  children,
  shouldShowModal,
  shouldBackgroundClickHideModal = true,
  backgroundColor = "rgba(24, 39, 59, 0.75)",
  hideModal,
  showModal,
  portaled = false,
}) => {
  if (!shouldShowModal) {
    return <></>;
  }

  const modalContent = (
    <div
      className="modals-wrapper-background"
      style={{ backgroundColor }}
      onClick={(e) => shouldBackgroundClickHideModal && e.currentTarget === e.target ? hideModal() : null}
    >
      {children}
    </div>
  );

  if (portaled) {
    const modalRoot = document.getElementById("modal-root");
    return modalRoot ? createPortal(modalContent, modalRoot) : <></>;
  }

  return modalContent;
};

export default ModalsWrapper;
